import React from 'react';
import { FaCheck } from "react-icons/fa6";

const Success = ({}) => {
  return (
    <div className='flex items-center justify-center min-h-screen pt-20'>
        <div className='max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center flex flex-col justify-center items-center'>
            <FaCheck color="green" size="48px" />
            {/**
            <div className='mb-6 text-center'>
                 <svg 
                className='mx-auto h-16 w-16 text-yellow-500' 
                fill='none' 
                stroke='currentColor' 
                viewBox='0 0 24 24'
                >
                <path 
                    strokeLinecap='round' 
                    strokeLinejoin='round' 
                    strokeWidth={2} 
                    d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z' 
                />
                </svg>
                
            </div>
            */ }
            <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                You are logged in!
            </h2>
            <p className='text-gray-600 mb-8'>
                Now that you are logged in, you can scan a customer's QR code to validate parking.
            </p>
            {/** 
            <Link
                to='/'
                className='inline-block w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200'
            >
                Return to Home
            </Link>
            */}
        </div>
    </div>
  )
}

export default Success;